import Avatar from '@mui/material/Avatar'

export default Avatar
